import { css } from 'styled-components';
export const primaryShadow = ({ theme }) => css `
  box-shadow: 0 1px 6px 0 ${theme.themeVariables.frameDropShadow};
`;
//# sourceMappingURL=primaryShadow.js.map